import { useEffect } from "react";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setToken } from "redux/Authenticate/authenticate";


function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
}

export default function useSetAuthentication() {
  const auth = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading
    ) {
      navigate("/login");
    }

    // if (auth?.user?.access_token) {
    //   // dispatch(setToken(auth.user.access_token));
 
    //   document.cookie = `token=${auth.user.access_token}; path=/; max-age=3600; SameSite=Lax`;
    // } else {
   
    //   const tokenFromCookie = getCookie("token");
    //   if (tokenFromCookie) {
    //     dispatch(setToken(tokenFromCookie));

    //   }
    // }
  }, [auth]);

  return {};
}